import { makeActionCreator } from '../../config/store/utils'

export const HIDE_MANAGEMENT_PANEL_SUCCESS = 'HIDE_MANAGEMENT_PANEL_SUCCESS'
export const SHOW_MANAGEMENT_PANEL_SUCCESS = 'SHOW_MANAGEMENT_PANEL_SUCCESS'
export const onHideManagementPanelSuccess = makeActionCreator(HIDE_MANAGEMENT_PANEL_SUCCESS)
export const onShowManagementPanelSuccess = makeActionCreator(SHOW_MANAGEMENT_PANEL_SUCCESS)

export const TOGGLE_MANAGMENT_PANEL_SUCCESS = 'TOGGLE_MANAGMENT_PANEL_SUCCESS'
export const onToggleManagmentPanelSuccess = makeActionCreator(TOGGLE_MANAGMENT_PANEL_SUCCESS)
